// @ts-nocheck
import React from 'react';
import Tooltip from '../../ui/Tooltip';

interface StringFieldConfig {
  minLength?: number;
  maxLength?: number;
  // Support snake_case format from workflow editor
  min_length?: number;
  max_length?: number;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
}

interface DynamicStringFieldProps {
  fieldId: string;
  label: string;
  description?: string;
  tooltip?: string;
  value: string;
  onChange: (value: string) => void;
  config: StringFieldConfig;
  isRequired?: boolean;
  error?: string;
}

export default function DynamicStringField({
  fieldId,
  label,
  description,
  tooltip,
  value,
  onChange,
  config,
  isRequired,
  error
}: DynamicStringFieldProps) {
  // Support both camelCase and snake_case formats
  const minLength = config.minLength ?? config.min_length;
  const maxLength = config.maxLength ?? config.max_length;
  const isMultiline = config.multiline ?? false;
  const rows = config.rows ?? 3;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (!maxLength || newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  const inputClassName = "w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-purple-500 focus:ring-1 focus:ring-purple-500/20";

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label htmlFor={fieldId} className="text-xs font-medium text-gray-300">
          {label}
          {isRequired && <span className="text-red-400 ml-1">*</span>}
        </label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <div className="w-4 h-4 bg-gray-700/50 border border-gray-600 rounded-full flex items-center justify-center cursor-help hover:bg-gray-600/50 transition-colors duration-200">
              <span className="text-xs text-gray-300 font-medium">?</span>
            </div>
          </Tooltip>
        )}
      </div>

      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}

      {isMultiline ? (
        <textarea
          id={fieldId}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          rows={rows}
          placeholder={config.placeholder || 'Enter text...'}
          className={`${inputClassName} resize-y min-h-[80px]`}
        />
      ) : (
        <input
          type="text"
          id={fieldId}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          placeholder={config.placeholder || 'Enter text...'}
          className={inputClassName}
        />
      )}

      {(minLength || maxLength) && (
        <p className={`text-xs ${
          minLength && value.length < minLength
            ? 'text-red-400'
            : 'text-gray-500'
        }`}>
          {value.length}
          {minLength && ` (min: ${minLength})`}
          {maxLength && ` / ${maxLength}`}
          {' characters'}
        </p>
      )}
      
      {error && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
}